import AmountFormatter from "../../../../../utils/AmountFormatter"

const ServiceLineChild = (data) => {
    return (
        <div className="Id_data d-flex flex-wrap gap-12">
            <div className="d-flex align-items-center gap-1">
                <div className="Id-Box Billed"></div>
                <div className="d-flex align-items-center gap-01">
                    <p className="text font-m fs-11">Billed:</p>
                    <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.PrimaryBilledAmount} /></p>
                </div>

            </div>
            <div className="br-right-0-5 br-clr-light"></div>
            <div className="d-flex align-items-center gap-1">
                <div className="Id-Box Allowed"></div>
                <div className="d-flex align-items-center gap-01">
                    <p className="text font-m fs-11">Allowed:</p>
                    <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.AllowedAmount} /></p>
                </div>

            </div>
            <div className="br-right-0-5 br-clr-light"></div>
            <div className="d-flex align-items-center gap-1">
                <div className="Id-Box Paid-bal"></div>
                <div className="d-flex align-items-center gap-01">
                    <p className="text font-m fs-11">Ins Paid:</p>
                    <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.PrimaryPaid + data?.serviceLineChildData?.SecondaryPaid} /></p>
                </div>

            </div>
            <div className="br-right-0-5 br-clr-light"></div>
            <div className="d-flex align-items-center gap-1">
                <div className="Id-Box Paid-bal"></div>
                <div className="d-flex align-items-center gap-01">
                    <p className="text font-m fs-11">Ins Bal:</p>
                    <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.InsuranceBalance} /></p>
                </div>

            </div>
            {data?.serviceLineChildData?.WriteOff ?
                <>
                    <div className="br-right-0-5 br-clr-light"></div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="Id-Box Writeoff-bal"></div>
                        <div className="d-flex align-items-center gap-01">
                            <p className="text font-m fs-11">Contr. Adj:</p>
                            <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.WriteOff} /></p>
                        </div>

                    </div>
                </>
                : null
            }
            {data?.serviceLineChildData?.DeniedAmount ?
                <>
                    <div className="br-right-0-5 br-clr-light"></div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="Id-Box Denied-bal"></div>
                        <div className="d-flex align-items-center gap-01">
                            <p className="text font-m fs-11">Denied:</p>
                            <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.DeniedAmount} /></p>
                        </div>
                    </div>
                </>
                : null
            }
            {data?.serviceLineChildData?.PatientPaid ?
                <>
                    <div className="br-right-0-5 br-clr-light"></div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="Id-Box Pat_Paid"></div>
                        <div className="d-flex align-items-center gap-01">
                            <p className="text font-m fs-11">Pat.Paid:</p>
                            <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.PatientPaid} /></p>
                        </div>

                    </div>
                </>
                : null
            }
            {data?.serviceLineChildData?.PatientBalance ?
                <>
                    <div className="br-right-0-5 br-clr-light"></div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="Id-Box PateintBalance"></div>
                        <div className="d-flex align-items-center gap-01">
                            <p className="text font-m fs-11">Pat.Bal:</p>
                            <p className="text fs-11"><AmountFormatter amount={data?.serviceLineChildData?.PatientBalance} /></p>
                        </div>

                    </div>
                </> : null
            }
            {data?.serviceLineChildData?.Copay ?
                <>
                    <div className="br-right-0-5 br-clr-light"></div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="Id-Box Copay"></div>
                        <div className="d-flex align-items-center gap-01">
                            <p className="text font-m fs-11">Copay:</p>
                            <p className="text fs-10"><AmountFormatter amount={data?.serviceLineChildData?.Copay} /></p>
                        </div>
                    </div>
                </> : null
            }
            {data?.serviceLineChildData?.Deductible ?
                <>
                    <div className="br-right-0-5 br-clr-light"></div>
                    <div className="d-flex align-items-center gap-1">
                        <div className="Id-Box Deductible"></div>
                        <div className="d-flex align-items-center gap-01">
                            <p className="text font-m fs-11">Deductible:</p>
                            <p className="text fs-10"><AmountFormatter amount={data?.serviceLineChildData?.Deductible} /></p>
                        </div>

                    </div>
                </>
                : null}
            {
                data?.serviceLineChildData?.CoInsurance ?
                    <>
                        <div className="br-right-0-5 br-clr-light"></div>
                        <div className="d-flex align-items-center gap-1">
                            <div className="Id-Box Co_insurance"></div>
                            <div className="d-flex align-items-center gap-01">
                                <p className="text font-m fs-11">Co Insurance:</p>
                                <p className="text fs-10"><AmountFormatter amount={data?.serviceLineChildData?.CoInsurance} /></p>
                            </div>

                        </div>
                    </>
                    : null
            }
             {
                data?.serviceLineChildData?.IncentiveAmount ?
                    <>
                        <div className="br-right-0-5 br-clr-light"></div>
                        <div className="d-flex align-items-center gap-1">
                            <div className="Id-Box Co_insurance"></div>
                            <div className="d-flex align-items-center gap-01">
                                <p className="text font-m fs-11">Incentive Amt:</p>
                                <p className="text fs-10"><AmountFormatter amount={data?.serviceLineChildData?.IncentiveAmount} /></p>
                            </div>

                        </div>
                    </>
                    : null
            }
        </div>
    )
}

export default ServiceLineChild